module.exports = __webpack_public_path__ + "assets/img/vue_starter_npm_setting.444bb0df.jpg";